import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-24 text-center md:px-8">
      <span className="font-heading text-7xl font-black text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-600">
        我们没有找到路径 <span className="font-mono text-foreground-800">{location.pathname}</span> 对应的页面。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-film-line" />
          浏览电影
        </Link>
      </div>
    </div>
  );
}